import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faPeopleGroup as freeFasFaPeopleGroup
} from '@fortawesome/free-solid-svg-icons'

import {
  faApple as freeFabFaApple,
  faGoogle as freeFabFaGoogle
} from '@fortawesome/free-brands-svg-icons'

import {
  faAward as proFalFaAward,
  faBriefcase as proFalFaBriefcase,
  faBuilding as proFalFaBuilding,
  faPhone as proFalFaPhone,
  faUserGroup as proFalFaUserGroup,
  faUserTie as proFalFaUserTie
} from '@fortawesome/pro-light-svg-icons'

import {
  faArrowLeft as proFasFaArrowLeft,
  faCalendarPlus as proFasFaCalendarPlus,
  faCalendarStar as proFasFaCalendarStar,
  faCaretDown as proFasFaCaretDown,
  faCaretUp as proFasFaCaretUp,
  faCalendarDays as proFasFaCalendarDays,
  faChevronRight as proFasFaChevronRight,
  faChevronLeft as proFasFaChevronLeft,
  faCircleInfo as proFasFaCircleInfo,
  faEraser as proFasFaEraser,
  faFileArrowDown as proFasFaFileArrowDown,
  faFilter as proFasFaFilter,
  faFlagCheckered as proFasFaFlagCheckered,
  faLock as proFasFaLock,
  faPeople as proFasFaPeople,
  faPerson as proFasFaPerson,
  faPlus as proFasFaPlus,
  faReply as proFasFaReply,
  faStar as proFasFaStar,
  faEye as proFasFaEye,
  faTags as proFasFaTags,
  faTimes as proFasFaTimes,
  faTransporter7 as proFasFaTransporter7,
  faUser as proFasFaUser,
  faUserPlus as proFasFaUserPlus,
  faRotate as proFasFaRotate,
  faPaperPlaneTop as proFasFaPaperPlaneTop
} from '@fortawesome/pro-solid-svg-icons'

import {
  faAddressBook as proFarFaAddressBook,
  faArrowCircleDown as proFarFaArrowCircleDown,
  faArrowRight as proFarFaArrowRight,
  faArrowRightFromBracket as proFarFaArrowRightFromBracket,
  faArrowRightLong as proFarFaArrowRightLong,
  faArrowRotateRight as proFarFaArrowRotateRight,
  faArrowUpRightFromSquare as proFarFaArrowUpRightFromSquare,
  faArrowsTurnToDots as proFarFaArrowsTurnToDots,
  faAt as proFarFaAt,
  faAward as proFarFaAward,
  faBars as proFarFaBars,
  faBellOn as proFarFaBellOn,
  faBuilding as proFarFaBuilding,
  faGlobe as proFarFaGlobe,
  faCalendar as proFarFaCalendar,
  faCalendarCheck as proFarFaCalendarCheck,
  faCalendarCircleUser as proFarFaCalendarCircleUser,
  faCalendarClock as proFarFaCalendarClock,
  faCalendarDay as proFarFaCalendarDay,
  faCalendarDays as proFarFaCalendarDays,
  faCalendarPlus as proFarFaCalendarPlus,
  faCalendarStar as proFarFaCalendarStar,
  faCamera as proFarFaCamera,
  faCartShopping as proFarFaCartShopping,
  faChartBar as proFarFaChartBar,
  faChartColumn as proFarFaChartColumn,
  faChartLineUp as proFarFaChartLineUp,
  faChartPie as proFarFaChartPie,
  faCheck as proFarFaCheck,
  faChevronDown as proFarFaChevronDown,
  faChevronLeft as proFarFaChevronLeft,
  faChevronRight as proFarFaChevronRight,
  faChevronUp as proFarFaChevronUp,
  faChevronsLeft as proFarFaChevronsLeft,
  faChevronsRight as proFarFaChevronsRight,
  faCircleCheck as proFarFaCircleCheck,
  faCircleDollar as proFarFaCircleDollar,
  faCircleEnvelope as proFarFaCircleEnvelope,
  faCircleExclamation as proFarFaCircleExclamation,
  faCircleInfo as proFarFaCircleInfo,
  faCircleStop as proFarFaCircleStop,
  faCircleUser as proFarFaCircleUser,
  faCircleXmark as proFarFaCircleXmark,
  faClipboard as proFarFaClipboard,
  faClipboardUser as proFarFaClipboardUser,
  faClock as proFarFaClock,
  faCommentXmark as proFarFaCommentXmark,
  faCopy as proFarFaCopy,
  faDash as proFarFaDash,
  faDoNotEnter as proFarFaDoNotEnter,
  faDoorClosed as proFarFaDoorClosed,
  faDoorOpen as proFarFaDoorOpen,
  faDownload as proFarFaDownload,
  faEarthEurope as proFarFaEarthEurope,
  faEllipsis as proFarFaEllipsis,
  faEllipsisVertical as proFarFaEllipsisVertical,
  faEmptySet as proFarFaEmptySet,
  faEnvelope as proFarFaEnvelope,
  faEraser as proFarFaEraser,
  faEyeLowVision as proFarFaEyeLowVision,
  faFileArrowDown as proFarFaFileArrowDown,
  faFileContract as proFarFaFileContract,
  faFileCsv as proFarFaFileCsv,
  faFileInvoice as proFarFaFileInvoice,
  faFileMedical as proFarFaFileMedical,
  faFilePdf as proFarFaFilePdf,
  faFilePen as proFarFaFilePen,
  faFilePlus as proFarFaFilePlus,
  faFileSignature as proFarFaFileSignature,
  faFilesMedical as proFarFaFilesMedical,
  faFilter as proFarFaFilter,
  faFlag as proFarFaFlag,
  faFloppyDisk as proFarFaFloppyDisk,
  faGear as proFarFaGear,
  faHandHolding as proFarFaHandHolding,
  faHandHoldingDollar as proFarFaHandHoldingDollar,
  faHouse as proFarFaHouse,
  faImage as proFarFaImage,
  faList as proFarFaList,
  faLocationDot as proFarFaLocationDot,
  faLock as proFarFaLock,
  faMagnifyingGlass as proFarFaMagnifyingGlass,
  faMessage as proFarFaMessage,
  faMessageExclamation as proFarFaMessageExclamation,
  faMessageLines as proFarFaMessageLines,
  faMessagePlus as proFarFaMessagePlus,
  faMessageSlash as proFarFaMessageSlash,
  faMessageSms as proFarFaMessageSms,
  faMessageXmark as proFarFaMessageXmark,
  faNoteSticky as proFarFaNoteSticky,
  faNotes as proFarFaNotes,
  faNotesMedical as proFarFaNotesMedical,
  faPaperPlane as proFarFaPaperPlane,
  faPaperclip as proFarFaPaperclip,
  faPen as proFarFaPen,
  faPencil as proFarFaPencil,
  faPeopleGroup as proFarFaPeopleGroup,
  faPercent as proFarFaPercent,
  faPhone as proFarFaPhone,
  faPhoneFlip as proFarFaPhoneFlip,
  faPiggyBank as proFarFaPiggyBank,
  faPlus as proFarFaPlus,
  faPrint as proFarFaPrint,
  faRepeat as proFarFaRepeat,
  faSpinnerThird as proFarFaSpinnerThird,
  faStar as proFarFaStar,
  faStopwatch as proFarFaStopwatch,
  faTag as proFarFaTag,
  faTags as proFarFaTags,
  faTally as proFarFaTally,
  faTimes as proFarFaTimes,
  faTrash as proFarFaTrash,
  faTriangleExclamation as proFarFaTriangleExclamation,
  faUser as proFarFaUser,
  faUserGroup as proFarFaUserGroup,
  faUserPlus as proFarFaUserPlus,
  faUserSlash as proFarFaUserSlash,
  faUsers as proFarFaUsers,
  faWrench as proFarFaWrench,
  faXmark as proFarFaXmark,
  faQuestion as proFarFaQuestion
} from '@fortawesome/pro-regular-svg-icons'

import {
  faCircleCheck as proFadFaCircleCheck,
  faCircleXmark as proFadFaCircleXmark,
  faCircleMinus as proFadFaCircleMinus
} from '@fortawesome/pro-duotone-svg-icons'

library.add(
  freeFasFaPeopleGroup,
  freeFabFaApple,
  freeFabFaGoogle,
  proFalFaAward,
  proFalFaBriefcase,
  proFalFaBuilding,
  proFalFaPhone,
  proFalFaUserGroup,
  proFalFaUserTie,
  proFasFaArrowLeft,
  proFasFaCalendarPlus,
  proFasFaCalendarStar,
  proFasFaCaretDown,
  proFasFaCaretUp,
  proFasFaCalendarDays,
  proFasFaChevronRight,
  proFasFaChevronLeft,
  proFasFaCircleInfo,
  proFasFaEraser,
  proFasFaFileArrowDown,
  proFasFaFilter,
  proFasFaFlagCheckered,
  proFasFaLock,
  proFasFaPeople,
  proFasFaPerson,
  proFasFaPlus,
  proFasFaReply,
  proFasFaStar,
  proFasFaEye,
  proFasFaTags,
  proFasFaTimes,
  proFasFaTransporter7,
  proFasFaUser,
  proFasFaUserPlus,
  proFasFaRotate,
  proFasFaPaperPlaneTop,
  proFarFaAddressBook,
  proFarFaArrowCircleDown,
  proFarFaArrowRight,
  proFarFaArrowRightFromBracket,
  proFarFaArrowRightLong,
  proFarFaArrowRotateRight,
  proFarFaArrowUpRightFromSquare,
  proFarFaArrowsTurnToDots,
  proFarFaAt,
  proFarFaAward,
  proFarFaBars,
  proFarFaBellOn,
  proFarFaBuilding,
  proFarFaGlobe,
  proFarFaCalendar,
  proFarFaCalendarCheck,
  proFarFaCalendarCircleUser,
  proFarFaCalendarClock,
  proFarFaCalendarDay,
  proFarFaCalendarDays,
  proFarFaCalendarPlus,
  proFarFaCalendarStar,
  proFarFaCamera,
  proFarFaCartShopping,
  proFarFaChartBar,
  proFarFaChartColumn,
  proFarFaChartLineUp,
  proFarFaChartPie,
  proFarFaCheck,
  proFarFaChevronDown,
  proFarFaChevronLeft,
  proFarFaChevronRight,
  proFarFaChevronUp,
  proFarFaChevronsLeft,
  proFarFaChevronsRight,
  proFarFaCircleCheck,
  proFarFaCircleDollar,
  proFarFaCircleEnvelope,
  proFarFaCircleExclamation,
  proFarFaCircleInfo,
  proFarFaCircleStop,
  proFarFaCircleUser,
  proFarFaCircleXmark,
  proFarFaClipboard,
  proFarFaClipboardUser,
  proFarFaClock,
  proFarFaCommentXmark,
  proFarFaCopy,
  proFarFaDash,
  proFarFaDoNotEnter,
  proFarFaDoorClosed,
  proFarFaDoorOpen,
  proFarFaDownload,
  proFarFaEarthEurope,
  proFarFaEllipsis,
  proFarFaEllipsisVertical,
  proFarFaEmptySet,
  proFarFaEnvelope,
  proFarFaEraser,
  proFarFaEyeLowVision,
  proFarFaFileArrowDown,
  proFarFaFileContract,
  proFarFaFileCsv,
  proFarFaFileInvoice,
  proFarFaFileMedical,
  proFarFaFilePdf,
  proFarFaFilePen,
  proFarFaFilePlus,
  proFarFaFileSignature,
  proFarFaFilesMedical,
  proFarFaFilter,
  proFarFaFlag,
  proFarFaFloppyDisk,
  proFarFaGear,
  proFarFaHandHolding,
  proFarFaHandHoldingDollar,
  proFarFaHouse,
  proFarFaImage,
  proFarFaList,
  proFarFaLocationDot,
  proFarFaLock,
  proFarFaMagnifyingGlass,
  proFarFaMessage,
  proFarFaMessageExclamation,
  proFarFaMessageLines,
  proFarFaMessagePlus,
  proFarFaMessageSlash,
  proFarFaMessageSms,
  proFarFaMessageXmark,
  proFarFaNoteSticky,
  proFarFaNotes,
  proFarFaNotesMedical,
  proFarFaPaperPlane,
  proFarFaPaperclip,
  proFarFaPen,
  proFarFaPencil,
  proFarFaPeopleGroup,
  proFarFaPercent,
  proFarFaPhone,
  proFarFaPhoneFlip,
  proFarFaPiggyBank,
  proFarFaPlus,
  proFarFaPrint,
  proFarFaRepeat,
  proFarFaSpinnerThird,
  proFarFaStar,
  proFarFaStopwatch,
  proFarFaTag,
  proFarFaTags,
  proFarFaTally,
  proFarFaTimes,
  proFarFaTrash,
  proFarFaTriangleExclamation,
  proFarFaUser,
  proFarFaUserGroup,
  proFarFaUserPlus,
  proFarFaUserSlash,
  proFarFaUsers,
  proFarFaWrench,
  proFarFaXmark,
  proFarFaQuestion,
  proFadFaCircleCheck,
  proFadFaCircleXmark,
  proFadFaCircleMinus
)

config.autoAddCss = false

Vue.component('faIcon', FontAwesomeIcon)
Vue.component('faLayers', FontAwesomeLayers)
Vue.component('faLayersText', FontAwesomeLayersText)
